import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import Layout from './components/Layout/Layout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Auth/Login';
import ResetPassword from './pages/Auth/ResetPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import Tracks from './pages/Tracks/Tracks';
import NewRelease from './pages/Tracks/NewRelease';
import TrackEdit from './pages/Tracks/TrackEdit';
import TrackDetail from './pages/Tracks/TrackDetail';
import Earnings from './pages/Earnings/Earnings';
import Notifications from './pages/Notifications';
import AdminPanel from './pages/Admin/AdminPanel';
import PendingReleases from './pages/Admin/PendingReleases';
import AllReleases from './pages/Admin/AllReleases';
import AdminEarnings from './pages/Admin/AdminEarnings';
import ArtistManagement from './pages/Admin/ArtistManagement';
import ArtistDetail from './pages/Admin/ArtistDetail';
import AdminNewRelease from './pages/Admin/AdminNewRelease';
import AdminTrackDetail from './pages/Admin/AdminTrackDetail';
import AdminTrackEdit from './pages/Admin/AdminTrackEdit';
import Support from './pages/Support/Support';
import NewTicket from './pages/Support/NewTicket';
import TicketDetail from './pages/Support/TicketDetail';
import AdminSupportDashboard from './pages/Admin/AdminSupportDashboard';
import AdminTicketDetail from './pages/Admin/AdminTicketDetail';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Policies from './pages/Policies';
import { CookieConsent } from './components/policies/CookieConsent';

function App() {
  return (
    <Router>
      <AuthProvider>
        <DataProvider>
          <div className="App">
            <CookieConsent />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/auth/reset-password" element={<ResetPassword />} />
              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/tracks" element={<Tracks />} />
                        <Route path="/tracks/new" element={<NewRelease />} />
                        <Route path="/tracks/edit/:id" element={<TrackEdit />} />
                        <Route path="/tracks/view/:id" element={<TrackDetail />} />
                        <Route path="/earnings" element={<Earnings />} />
                        <Route path="/notifications" element={<Notifications />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/support/new" element={<NewTicket />} />
                        <Route path="/support/:ticketId" element={<TicketDetail />} />
                        <Route path="/admin" element={<AdminPanel />} />
                        <Route path="/admin/pending" element={<PendingReleases />} />
                        <Route path="/admin/releases" element={<AllReleases />} />
                        <Route path="/admin/earnings" element={<AdminEarnings />} />
                        <Route path="/admin/artists" element={<ArtistManagement />} />
                        <Route path="/admin/artists/:artistId" element={<ArtistDetail />} />
                        <Route path="/admin/releases/new" element={<AdminNewRelease />} />
                        <Route path="/admin/tracks/view/:id" element={<AdminTrackDetail />} />
                        <Route path="/admin/tracks/edit/:id" element={<AdminTrackEdit />} />
                        <Route path="/admin/support" element={<AdminSupportDashboard />} />
                        <Route path="/admin/support/:ticketId" element={<AdminTicketDetail />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tracks/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Tracks />} />
                        <Route path="/new" element={<NewRelease />} />
                        <Route path="/edit/:id" element={<TrackEdit />} />
                        <Route path="/view/:id" element={<TrackDetail />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/earnings"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Earnings />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notifications"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Notifications />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<AdminPanel />} />
                        <Route path="/pending" element={<PendingReleases />} />
                        <Route path="/releases" element={<AllReleases />} />
                        <Route path="/earnings" element={<AdminEarnings />} />
                        <Route path="/artists" element={<ArtistManagement />} />
                        <Route path="/artists/:artistId" element={<ArtistDetail />} />
                        <Route path="/releases/new" element={<AdminNewRelease />} />
                        <Route path="/tracks/view/:id" element={<AdminTrackDetail />} />
                        <Route path="/tracks/edit/:id" element={<AdminTrackEdit />} />
                        <Route path="/support" element={<AdminSupportDashboard />} />
                        <Route path="/support/:ticketId" element={<AdminTicketDetail />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/support/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Support />} />
                        <Route path="/new" element={<NewTicket />} />
                        <Route path="/:ticketId" element={<TicketDetail />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </DataProvider>
      </AuthProvider>
    </Router>
  );
}

export default App; 